/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as NotAuthedRouteRouteImport } from "./routes/_not-authed/route";
import { Route as AuthedRouteRouteImport } from "./routes/_authed/route";
import { Route as AuthedIndexRouteImport } from "./routes/_authed/index";
import { Route as NotAuthedSignUpRouteImport } from "./routes/_not-authed/sign-up";
import { Route as NotAuthedSignInRouteImport } from "./routes/_not-authed/sign-in";
import { Route as AuthedMyClansRouteImport } from "./routes/_authed/my-clans";
import { Route as AuthedMyPlayersRouteRouteImport } from "./routes/_authed/my-players/route";
import { Route as AuthedMyPlayersIndexRouteImport } from "./routes/_authed/my-players/index";
import { Route as AuthedClanWarPlannerIndexRouteImport } from "./routes/_authed/clan-war-planner/index";
import { Route as AuthedMyPlayersTagRouteRouteImport } from "./routes/_authed/my-players/$tag/route";
import { Route as AuthedMyPlayersTagIndexRouteImport } from "./routes/_authed/my-players/$tag/index";
import { Route as AuthedMyPlayersTagSocialMediaRouteImport } from "./routes/_authed/my-players/$tag/social-media";
import { Route as AuthedMyPlayersTagSearchFilterRouteImport } from "./routes/_authed/my-players/$tag/search-filter";
import { Route as AuthedMyPlayersTagNotificationsRouteImport } from "./routes/_authed/my-players/$tag/notifications";
import { Route as AuthedMyPlayersTagMatchsRouteImport } from "./routes/_authed/my-players/$tag/matchs";
import { Route as AuthedMyPlayersTagClansRouteImport } from "./routes/_authed/my-players/$tag/clans";

const NotAuthedRouteRoute = NotAuthedRouteRouteImport.update({
  id: "/_not-authed",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedRouteRoute = AuthedRouteRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedRouteRoute,
} as any);
const NotAuthedSignUpRoute = NotAuthedSignUpRouteImport.update({
  id: "/sign-up",
  path: "/sign-up",
  getParentRoute: () => NotAuthedRouteRoute,
} as any);
const NotAuthedSignInRoute = NotAuthedSignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => NotAuthedRouteRoute,
} as any);
const AuthedMyClansRoute = AuthedMyClansRouteImport.update({
  id: "/my-clans",
  path: "/my-clans",
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedMyPlayersRouteRoute = AuthedMyPlayersRouteRouteImport.update({
  id: "/my-players",
  path: "/my-players",
  getParentRoute: () => AuthedRouteRoute,
} as any);
const AuthedMyPlayersIndexRoute = AuthedMyPlayersIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedMyPlayersRouteRoute,
} as any);
const AuthedClanWarPlannerIndexRoute =
  AuthedClanWarPlannerIndexRouteImport.update({
    id: "/clan-war-planner/",
    path: "/clan-war-planner/",
    getParentRoute: () => AuthedRouteRoute,
  } as any);
const AuthedMyPlayersTagRouteRoute = AuthedMyPlayersTagRouteRouteImport.update({
  id: "/$tag",
  path: "/$tag",
  getParentRoute: () => AuthedMyPlayersRouteRoute,
} as any);
const AuthedMyPlayersTagIndexRoute = AuthedMyPlayersTagIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedMyPlayersTagRouteRoute,
} as any);
const AuthedMyPlayersTagSocialMediaRoute =
  AuthedMyPlayersTagSocialMediaRouteImport.update({
    id: "/social-media",
    path: "/social-media",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagSearchFilterRoute =
  AuthedMyPlayersTagSearchFilterRouteImport.update({
    id: "/search-filter",
    path: "/search-filter",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagNotificationsRoute =
  AuthedMyPlayersTagNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagMatchsRoute =
  AuthedMyPlayersTagMatchsRouteImport.update({
    id: "/matchs",
    path: "/matchs",
    getParentRoute: () => AuthedMyPlayersTagRouteRoute,
  } as any);
const AuthedMyPlayersTagClansRoute = AuthedMyPlayersTagClansRouteImport.update({
  id: "/clans",
  path: "/clans",
  getParentRoute: () => AuthedMyPlayersTagRouteRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof AuthedIndexRoute;
  "/my-players": typeof AuthedMyPlayersRouteRouteWithChildren;
  "/my-clans": typeof AuthedMyClansRoute;
  "/sign-in": typeof NotAuthedSignInRoute;
  "/sign-up": typeof NotAuthedSignUpRoute;
  "/my-players/$tag": typeof AuthedMyPlayersTagRouteRouteWithChildren;
  "/clan-war-planner/": typeof AuthedClanWarPlannerIndexRoute;
  "/my-players/": typeof AuthedMyPlayersIndexRoute;
  "/my-players/$tag/clans": typeof AuthedMyPlayersTagClansRoute;
  "/my-players/$tag/matchs": typeof AuthedMyPlayersTagMatchsRoute;
  "/my-players/$tag/notifications": typeof AuthedMyPlayersTagNotificationsRoute;
  "/my-players/$tag/search-filter": typeof AuthedMyPlayersTagSearchFilterRoute;
  "/my-players/$tag/social-media": typeof AuthedMyPlayersTagSocialMediaRoute;
  "/my-players/$tag/": typeof AuthedMyPlayersTagIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof AuthedIndexRoute;
  "/my-clans": typeof AuthedMyClansRoute;
  "/sign-in": typeof NotAuthedSignInRoute;
  "/sign-up": typeof NotAuthedSignUpRoute;
  "/clan-war-planner": typeof AuthedClanWarPlannerIndexRoute;
  "/my-players": typeof AuthedMyPlayersIndexRoute;
  "/my-players/$tag/clans": typeof AuthedMyPlayersTagClansRoute;
  "/my-players/$tag/matchs": typeof AuthedMyPlayersTagMatchsRoute;
  "/my-players/$tag/notifications": typeof AuthedMyPlayersTagNotificationsRoute;
  "/my-players/$tag/search-filter": typeof AuthedMyPlayersTagSearchFilterRoute;
  "/my-players/$tag/social-media": typeof AuthedMyPlayersTagSocialMediaRoute;
  "/my-players/$tag": typeof AuthedMyPlayersTagIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_authed": typeof AuthedRouteRouteWithChildren;
  "/_not-authed": typeof NotAuthedRouteRouteWithChildren;
  "/_authed/my-players": typeof AuthedMyPlayersRouteRouteWithChildren;
  "/_authed/my-clans": typeof AuthedMyClansRoute;
  "/_not-authed/sign-in": typeof NotAuthedSignInRoute;
  "/_not-authed/sign-up": typeof NotAuthedSignUpRoute;
  "/_authed/": typeof AuthedIndexRoute;
  "/_authed/my-players/$tag": typeof AuthedMyPlayersTagRouteRouteWithChildren;
  "/_authed/clan-war-planner/": typeof AuthedClanWarPlannerIndexRoute;
  "/_authed/my-players/": typeof AuthedMyPlayersIndexRoute;
  "/_authed/my-players/$tag/clans": typeof AuthedMyPlayersTagClansRoute;
  "/_authed/my-players/$tag/matchs": typeof AuthedMyPlayersTagMatchsRoute;
  "/_authed/my-players/$tag/notifications": typeof AuthedMyPlayersTagNotificationsRoute;
  "/_authed/my-players/$tag/search-filter": typeof AuthedMyPlayersTagSearchFilterRoute;
  "/_authed/my-players/$tag/social-media": typeof AuthedMyPlayersTagSocialMediaRoute;
  "/_authed/my-players/$tag/": typeof AuthedMyPlayersTagIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/my-players"
    | "/my-clans"
    | "/sign-in"
    | "/sign-up"
    | "/my-players/$tag"
    | "/clan-war-planner/"
    | "/my-players/"
    | "/my-players/$tag/clans"
    | "/my-players/$tag/matchs"
    | "/my-players/$tag/notifications"
    | "/my-players/$tag/search-filter"
    | "/my-players/$tag/social-media"
    | "/my-players/$tag/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/my-clans"
    | "/sign-in"
    | "/sign-up"
    | "/clan-war-planner"
    | "/my-players"
    | "/my-players/$tag/clans"
    | "/my-players/$tag/matchs"
    | "/my-players/$tag/notifications"
    | "/my-players/$tag/search-filter"
    | "/my-players/$tag/social-media"
    | "/my-players/$tag";
  id:
    | "__root__"
    | "/_authed"
    | "/_not-authed"
    | "/_authed/my-players"
    | "/_authed/my-clans"
    | "/_not-authed/sign-in"
    | "/_not-authed/sign-up"
    | "/_authed/"
    | "/_authed/my-players/$tag"
    | "/_authed/clan-war-planner/"
    | "/_authed/my-players/"
    | "/_authed/my-players/$tag/clans"
    | "/_authed/my-players/$tag/matchs"
    | "/_authed/my-players/$tag/notifications"
    | "/_authed/my-players/$tag/search-filter"
    | "/_authed/my-players/$tag/social-media"
    | "/_authed/my-players/$tag/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AuthedRouteRoute: typeof AuthedRouteRouteWithChildren;
  NotAuthedRouteRoute: typeof NotAuthedRouteRouteWithChildren;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_not-authed": {
      id: "/_not-authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof NotAuthedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed": {
      id: "/_authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/": {
      id: "/_authed/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof AuthedIndexRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    "/_not-authed/sign-up": {
      id: "/_not-authed/sign-up";
      path: "/sign-up";
      fullPath: "/sign-up";
      preLoaderRoute: typeof NotAuthedSignUpRouteImport;
      parentRoute: typeof NotAuthedRouteRoute;
    };
    "/_not-authed/sign-in": {
      id: "/_not-authed/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof NotAuthedSignInRouteImport;
      parentRoute: typeof NotAuthedRouteRoute;
    };
    "/_authed/my-clans": {
      id: "/_authed/my-clans";
      path: "/my-clans";
      fullPath: "/my-clans";
      preLoaderRoute: typeof AuthedMyClansRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    "/_authed/my-players": {
      id: "/_authed/my-players";
      path: "/my-players";
      fullPath: "/my-players";
      preLoaderRoute: typeof AuthedMyPlayersRouteRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    "/_authed/my-players/": {
      id: "/_authed/my-players/";
      path: "/";
      fullPath: "/my-players/";
      preLoaderRoute: typeof AuthedMyPlayersIndexRouteImport;
      parentRoute: typeof AuthedMyPlayersRouteRoute;
    };
    "/_authed/clan-war-planner/": {
      id: "/_authed/clan-war-planner/";
      path: "/clan-war-planner";
      fullPath: "/clan-war-planner/";
      preLoaderRoute: typeof AuthedClanWarPlannerIndexRouteImport;
      parentRoute: typeof AuthedRouteRoute;
    };
    "/_authed/my-players/$tag": {
      id: "/_authed/my-players/$tag";
      path: "/$tag";
      fullPath: "/my-players/$tag";
      preLoaderRoute: typeof AuthedMyPlayersTagRouteRouteImport;
      parentRoute: typeof AuthedMyPlayersRouteRoute;
    };
    "/_authed/my-players/$tag/": {
      id: "/_authed/my-players/$tag/";
      path: "/";
      fullPath: "/my-players/$tag/";
      preLoaderRoute: typeof AuthedMyPlayersTagIndexRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/social-media": {
      id: "/_authed/my-players/$tag/social-media";
      path: "/social-media";
      fullPath: "/my-players/$tag/social-media";
      preLoaderRoute: typeof AuthedMyPlayersTagSocialMediaRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/search-filter": {
      id: "/_authed/my-players/$tag/search-filter";
      path: "/search-filter";
      fullPath: "/my-players/$tag/search-filter";
      preLoaderRoute: typeof AuthedMyPlayersTagSearchFilterRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/notifications": {
      id: "/_authed/my-players/$tag/notifications";
      path: "/notifications";
      fullPath: "/my-players/$tag/notifications";
      preLoaderRoute: typeof AuthedMyPlayersTagNotificationsRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/matchs": {
      id: "/_authed/my-players/$tag/matchs";
      path: "/matchs";
      fullPath: "/my-players/$tag/matchs";
      preLoaderRoute: typeof AuthedMyPlayersTagMatchsRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
    "/_authed/my-players/$tag/clans": {
      id: "/_authed/my-players/$tag/clans";
      path: "/clans";
      fullPath: "/my-players/$tag/clans";
      preLoaderRoute: typeof AuthedMyPlayersTagClansRouteImport;
      parentRoute: typeof AuthedMyPlayersTagRouteRoute;
    };
  }
}

interface AuthedMyPlayersTagRouteRouteChildren {
  AuthedMyPlayersTagClansRoute: typeof AuthedMyPlayersTagClansRoute;
  AuthedMyPlayersTagMatchsRoute: typeof AuthedMyPlayersTagMatchsRoute;
  AuthedMyPlayersTagNotificationsRoute: typeof AuthedMyPlayersTagNotificationsRoute;
  AuthedMyPlayersTagSearchFilterRoute: typeof AuthedMyPlayersTagSearchFilterRoute;
  AuthedMyPlayersTagSocialMediaRoute: typeof AuthedMyPlayersTagSocialMediaRoute;
  AuthedMyPlayersTagIndexRoute: typeof AuthedMyPlayersTagIndexRoute;
}

const AuthedMyPlayersTagRouteRouteChildren: AuthedMyPlayersTagRouteRouteChildren =
  {
    AuthedMyPlayersTagClansRoute: AuthedMyPlayersTagClansRoute,
    AuthedMyPlayersTagMatchsRoute: AuthedMyPlayersTagMatchsRoute,
    AuthedMyPlayersTagNotificationsRoute: AuthedMyPlayersTagNotificationsRoute,
    AuthedMyPlayersTagSearchFilterRoute: AuthedMyPlayersTagSearchFilterRoute,
    AuthedMyPlayersTagSocialMediaRoute: AuthedMyPlayersTagSocialMediaRoute,
    AuthedMyPlayersTagIndexRoute: AuthedMyPlayersTagIndexRoute,
  };

const AuthedMyPlayersTagRouteRouteWithChildren =
  AuthedMyPlayersTagRouteRoute._addFileChildren(
    AuthedMyPlayersTagRouteRouteChildren,
  );

interface AuthedMyPlayersRouteRouteChildren {
  AuthedMyPlayersTagRouteRoute: typeof AuthedMyPlayersTagRouteRouteWithChildren;
  AuthedMyPlayersIndexRoute: typeof AuthedMyPlayersIndexRoute;
}

const AuthedMyPlayersRouteRouteChildren: AuthedMyPlayersRouteRouteChildren = {
  AuthedMyPlayersTagRouteRoute: AuthedMyPlayersTagRouteRouteWithChildren,
  AuthedMyPlayersIndexRoute: AuthedMyPlayersIndexRoute,
};

const AuthedMyPlayersRouteRouteWithChildren =
  AuthedMyPlayersRouteRoute._addFileChildren(AuthedMyPlayersRouteRouteChildren);

interface AuthedRouteRouteChildren {
  AuthedMyPlayersRouteRoute: typeof AuthedMyPlayersRouteRouteWithChildren;
  AuthedMyClansRoute: typeof AuthedMyClansRoute;
  AuthedIndexRoute: typeof AuthedIndexRoute;
  AuthedClanWarPlannerIndexRoute: typeof AuthedClanWarPlannerIndexRoute;
}

const AuthedRouteRouteChildren: AuthedRouteRouteChildren = {
  AuthedMyPlayersRouteRoute: AuthedMyPlayersRouteRouteWithChildren,
  AuthedMyClansRoute: AuthedMyClansRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedClanWarPlannerIndexRoute: AuthedClanWarPlannerIndexRoute,
};

const AuthedRouteRouteWithChildren = AuthedRouteRoute._addFileChildren(
  AuthedRouteRouteChildren,
);

interface NotAuthedRouteRouteChildren {
  NotAuthedSignInRoute: typeof NotAuthedSignInRoute;
  NotAuthedSignUpRoute: typeof NotAuthedSignUpRoute;
}

const NotAuthedRouteRouteChildren: NotAuthedRouteRouteChildren = {
  NotAuthedSignInRoute: NotAuthedSignInRoute,
  NotAuthedSignUpRoute: NotAuthedSignUpRoute,
};

const NotAuthedRouteRouteWithChildren = NotAuthedRouteRoute._addFileChildren(
  NotAuthedRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  AuthedRouteRoute: AuthedRouteRouteWithChildren,
  NotAuthedRouteRoute: NotAuthedRouteRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
